import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RxAccordionModule } from '@nrwl/rx-accordion';
import { RxListCompositeComponent } from './rx-list-composite.component';
import { RxPipesModule } from '@nrwl/rx-pipes';
import { RxSearchModule } from '@nrwl/rx-search';
import { RxUiModule } from '@nrwl/rx-ui';
import { RxNoDataModule } from '@nrwl/rx-no-data';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RxSearchModule,
    RxUiModule,
    RxAccordionModule,
    RxPipesModule,
    RxNoDataModule,
    RxListCompositeComponent,
  ],
  exports: [RxListCompositeComponent],
})
export class RxListCompositeModule {}
